import { apiBaseUrl } from 'yxt-biz-pc/packages/api';

// 标签分类列表
export const getTagCatalogList = _ => apiBaseUrl.get('talentrv/mgr/tagcatalog/list');
// 贴标签列表
export const getLabellingList = data => apiBaseUrl.post('talentrv/mgr/search/tag/list', data);
